<template>
  <div>
    <div class="category-area">
      <div class="">
        <button
          class="btn-edit-activity"
          @click.prevent="$emit('editActivity', record)"
        >
          <img src="@/assets/images/icons/edit.svg" alt="" />
        </button>
      </div>
      <div
        class="w-100 d-flex justify-content-between"
        @click.prevent="isOpen = !isOpen"
      >
        <span>{{ record.name }}</span>
        <div>
          <img
            v-if="isOpen"
            src="@/assets/images/icons/icon-matriz-iper/icon-left-3.png"
            alt=""
          />
          <img
            v-else
            src="@/assets/images/icons/icon-matriz-iper/icon-left-2.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div v-if="isOpen">
      <div class="mb-3">
        <button
          class="btn-calification"
          @click.prevent="$emit('calification', record)"
        >
          <img
            v-if="record?.iper?.length > 0 "
            src="@/assets/images/icons/icon-matriz-iper/eye.png"
            alt=""
          />
          <img v-else src="@/assets/images/icons/icon-matriz-iper/sin-calification.png" alt="" />
          <span class="ml-2">{{ record?.iper?.length > 0 ? 'Ver calificación' : 'Sin Calificación'}}</span>
        </button>
        <button
          v-if="record?.iper?.length > 0"
          class="btn-calification mt-3"
          @click.prevent="$emit('history', record?.iper[0]?.id)"
        >
          <img src="@/assets/images/icons/refresh-oclok.png" alt="" class="mr-2" />
          Historial de modificaciones
        </button>
      </div>
      <div class="mt-3" v-if="record?.iper?.length > 0">
        <div class="content-risks-activity">
          <span>Sin mitigación</span>
          <div
            class="risk-activity"
            :style="{
              backgroundColor: noMitigation?.background,
              color: noMitigation?.color,
            }"
          >
            <img class="mr-2" :src="noMitigation?.icon" alt="" />
            <span>{{ noMitigation?.name }}</span>
          </div>
        </div>
        <div class="content-risks-activity mt-3 mb-4">
          <span>Con mitigación</span>
          <div
            class="risk-activity"
            :style="{
              backgroundColor: mitigation?.background,
              color: mitigation?.color,
            }"
          >
            <img class="mr-2" :src="mitigation?.icon" alt="" />
            <span>{{ mitigation?.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    record: {
      type: Object,
      default: null,
    },
    risks: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      listCategories: [
        {
          id: 1,
          name: "Sin calificación",
          img: require("@/assets/images/icons/icon-matriz-iper/sin-calification.png"),
        },
        {
          id: 2,
          name: "Riesgo muy alto",
          img: require("@/assets/images/icons/icon-matriz-iper/risk-muy-alto.png"),
        },
        {
          id: 3,
          name: "Riesgo alto",
          img: require("@/assets/images/icons/icon-matriz-iper/risk-alto.png"),
        },
        {
          id: 4,
          name: "Riesgo Sustancial",
          img: require("@/assets/images/icons/icon-matriz-iper/risk-sustancial.png"),
        },
        {
          id: 5,
          name: "Riesgo posible",
          img: require("@/assets/images/icons/icon-matriz-iper/risk-posible.png"),
        },
        {
          id: 6,
          name: "Riesgo leve",
          img: require("@/assets/images/icons/icon-matriz-iper/risk-leve.png"),
        },
      ],
      isOpen: false,
      mitigation: null,
      noMitigation: null,
    };
  },
  methods: {
    classificationRisk(score) {
      const me = this;
      let risk = me.risks.find((risk) => {
        // Si el score es un rango [min, max], verificar si el número está en ese rango
        if (risk.score.length === 2) {
          return score >= risk.score[0] && score <= risk.score[1];
        }
        // Si el score es un valor único
        return score <= risk.score[0];
      });
      return risk;
    },
  },
  mounted() {
    const me = this;
    if (me.record?.iper?.length > 0) {
      const item = me.record?.iper[0];
      me.mitigation = me.classificationRisk(item.mitigation_score);
      me.noMitigation = me.classificationRisk(item.without_mitigation_score);
    }
  },
};
</script>

<style lang="scss" scoped>
.category-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  margin-bottom: 8px;
}
.category-area span {
  background-color: #ececff;
  padding: 4px;
  width: 100%;
  color: #263238;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;
  padding-left: 8px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.btn-calification {
  border: none;
  width: 85%;
  padding: 5px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-edit-activity {
  border: none;
  background-color: #5d5fef;
  color: white;
  padding: 5px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  img {
    width: 20px;
  }
}
</style>
